export default __webpack_public_path__ + "static/media/waiting_2.be919c98.png";